import React from 'react';
import {BaseIcon, iconDefaultProps, iconPropTypes} from './base-icon';
export const EditIcon = ({...props}) => (
	<BaseIcon {...props}>
		<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M16.5681 3.78948L8.61307 11.7445C8.50595 11.8516 8.43647 11.9906 8.41507 12.1405L7.9734 15.2347C7.94226 15.4528 8.01565 15.6729 8.17148 15.8287C8.3273 15.9845 8.54738 16.0578 8.7655 16.0266L11.8588 15.5841C12.0087 15.5626 12.1476 15.4932 12.2547 15.3861L19.3233 8.31746L19.3255 8.31527L19.3277 8.31307L20.2097 7.4311C21.2153 6.42549 21.2153 4.79509 20.2097 3.78948C19.2041 2.78388 17.5737 2.78388 16.5681 3.78948ZM19.2197 4.77943C18.7609 4.32056 18.0169 4.32056 17.558 4.77943L17.1688 5.16862L18.8305 6.83034L19.2197 6.44115C19.6786 5.98228 19.6786 5.2383 19.2197 4.77943ZM11.4297 14.2312L17.8406 7.82029L16.1789 6.15857L9.76804 12.5694L9.49125 14.5085L11.4297 14.2312Z"
				fill="#393946"
			/>
			<path
				d="M4.69999 7.39999C4.69999 6.4611 5.4611 5.69999 6.39999 5.69999H11.5625C11.9491 5.69999 12.2625 5.38659 12.2625 4.99999C12.2625 4.61339 11.9491 4.29999 11.5625 4.29999H6.39999C4.68791 4.29999 3.29999 5.6879 3.29999 7.39999V17.6C3.29999 19.3121 4.6879 20.7 6.39999 20.7H16.6C18.3121 20.7 19.7 19.3121 19.7 17.6V12.4375C19.7 12.0509 19.3866 11.7375 19 11.7375C18.6134 11.7375 18.3 12.0509 18.3 12.4375V17.6C18.3 18.5389 17.5389 19.3 16.6 19.3H6.39999C5.4611 19.3 4.69999 18.5389 4.69999 17.6V7.39999Z"
				fill="#393946"
			/>
		</svg>
	</BaseIcon>
);

EditIcon.propTypes = iconPropTypes;
EditIcon.defaultProps = iconDefaultProps;
